module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "modal-dialog "
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Take me Home")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h2', [_c('strong', [_vm._v("404 Page not found "), _c('i', {
    staticClass: "fa fa-meh-o"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "well",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('h2', [_vm._v(" Oops the page requested was not Found")])]), _vm._v(" "), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2b4f3231!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SharedComponents/NotFound.vue
// module id = 619
// module chunks = 2